<template>
  <Card>
    <Form ref="searchForm" :model="searchForm" inline :label-width="0">
      <Row>
        <Col span="16">
          <FormItem prop="spCode">
            <Select
              v-model="searchForm.spCode"
              placeholder="请选择资金商分组"
              style="width: 200px"
            >
              <Option
                :key="index"
                :value="item.code"
                v-for="(item, index) in spGroupQueryAll"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- <FormItem prop="platformCode">
            <Select
              v-model="searchForm.platformCode"
              placeholder="请选择平台编码"
              style="width: 200px"
            >
              <Option
                :key="index"
                :value="item.value"
                v-for="(item, index) in platformCodeList"
                >{{ item.label }}
              </Option>
            </Select>
          </FormItem> -->
          <FormItem style="margin-left: 15px">
            <Button
              type="primary"
              icon="md-search"
              @click="handleSearch"
              v-access="'priceInfo.query'"
              >搜索
            </Button>
            <Button @click="resetList()" v-access="'priceInfo.reset'"
              >重置</Button
            >
            <Button
              type="primary"
              icon="md-search"
              @click="handleAdd"
              v-access="'priceInfo.add'"
              >新增
            </Button>
          </FormItem>
        </Col>
        <Col span="8">
          <Button type="info" class="public-fr">批量导入</Button>
          <Button type="info" class="public-fr">批量导出</Button>
        </Col>
      </Row>
    </Form>
    <Table
      :style="{ marginTop: '20px' }"
      border
      stripe
      :loading="loading"
      :columns="columns"
      :data="tbList"
    >
      <template slot-scope="{ row, index }" slot="action">
        <a
          href="javascript:;"
          @click="handleEdit(row, index)"
          v-access="'priceInfo.edit'"
          >编辑</a
        >
        <a
          href="javascript:;"
          @click="detailFn(row, index)"
          v-access="'priceInfo.details'"
          >详情</a
        >
        <a
          href="javascript:;"
          @click="removeFn(index, row)"
          v-access="'priceInfo.delete'"
          >删除</a
        >
      </template>
    </Table>
    <Page
      :total="total"
      show-sizer
      show-total
      prev-text="上一页"
      next-text="下一页"
      show-elevator
      :current="searchForm.page"
      :page-size="searchForm.pageSize"
      @on-change="pageChange"
      @on-page-size-change="pageSizeChange"
      class="public-page"
    />
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formTitle"
      :mask-closable="false"
      footer-hide
    >
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="120"
      >
        <FormItem label="厂商指导价" prop="factoryPrice">
          <Input
            v-model="formValidate.factoryPrice"
            placeholder="请输入厂商指导价"
            style="width: 200px"
          ></Input>
        </FormItem>
        <!-- <FormItem label="平台编码" prop="platformCode">
          <Select
            v-model="formValidate.platformCode"
            placeholder="请选择"
            style="width: 200px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in platformCodeList"
              >{{ item.label }}
            </Option>
          </Select>
        </FormItem> -->
        <FormItem label="价格" prop="price">
          <Input
            v-model="formValidate.price"
            placeholder="请输入价格"
            style="width: 200px"
          ></Input>
        </FormItem>
        <FormItem label="定价分组" prop="priceSpGroup">
          <Select
            v-model="formValidate.priceSpGroup"
            placeholder="请选择定价分组"
            style="width: 200px"
          >
            <Option
              :key="index"
              :value="item.code"
              v-for="(item, index) in spGroupQueryAll"
              >{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="门店等级编码" prop="retGrade">
          <RadioGroup v-model="formValidate.retGrade">
            <Radio label="GT">
              <span>GT门店</span>
            </Radio>
            <Radio label="RKMBS">
              <span>RKMBS门店</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="建议零售价" prop="retailPrice">
          <Input
            v-model="formValidate.retailPrice"
            placeholder="请输入建议零售价"
            style="width: 200px"
          ></Input>
        </FormItem>
        <FormItem label="SKU编码" prop="skuCode">
          <Input
            v-model="formValidate.skuCode"
            placeholder="请输入SKU编码"
            style="width: 200px"
          ></Input>
        </FormItem>
        <FormItem label="资金商编码" prop="spCode">
          <Select
            v-model="formValidate.spCode"
            placeholder="请选择资金商编码"
            style="width: 200px"
          >
            <Option
              :key="index"
              :value="item.code"
              v-for="(item, index) in spInfoQueryAll"
              >{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="供货分组" prop="spGroup">
          <Select
            v-model="formValidate.spGroup"
            placeholder="请选择供货分组"
            style="width: 200px"
          >
            <Option
              :key="index"
              :value="item.code"
              v-for="(item, index) in spGroupQueryAll"
              >{{ item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="未税价" prop="untaxedPrice">
          <Input
            v-model="formValidate.untaxedPrice"
            placeholder="请输入未税价"
            style="width: 200px"
          ></Input>
        </FormItem>
        <FormItem style="margin-left: 15px; margin-top: 20px" class="br">
          <Button @click="handleCancel">取消</Button>
          <Button @click="handleSave" type="primary" style="margin-left: 10px"
            >确定</Button
          >
        </FormItem>
      </Form>
    </Modal>
  </Card>
</template>

<script>
const initFormValidate = {
  factoryPrice: "",
  // platformCode: "",
  price: "",
  priceSpGroup: "",
  retGrade: "",
  retailPrice: "",
  skuCode: "",
  spCode: "",
  spGroup: "",
  untaxedPrice: "",
};
const validateHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    return {
      total: 0,
      loading: false,
      modalLoading: false,
      tbList: [],
      searchName: "",
      editId: "",
      searchForm: {
        page: 1,
        pageSize: 10,
        spCode: "",
        // platformCode: "",
      },
      spInfoQueryAll: [],
      spGroupQueryAll: [],
      formModel: false,
      formTitle: "编辑",
      formValidate: { ...initFormValidate },
      columns: [
        {
          title: "序号",
          type: "index",
        },
        // {
        //   title: "平台",
        //   key: "platformName",
        // },
        {
          title: "门店等级",
          key: "retGrade",
        },
        {
          title: "资金商SP group",
          key: "spGroup",
        },
        {
          title: "价格取值资金商",
          key: "priceSpGroup",
        },
        {
          title: "建议零售价",
          key: "price",
        },
        {
          title: "SKU",
          key: "erpCode",
          minWidth: 160,
          render: (h, params) => {
            const { row } = params;
            return h(
              "a",
              {
                props: {
                  type: "primary",
                  size: "small",
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  click: () => this.handleOpenDeatil(row.skuCode),
                },
              },
              row.erpCode
            );
          },
        },
        {
          title: "未税金额",
          key: "untaxedPrice",
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
        },
      ],
      platformCodeList: [
        { label: "易购APP", value: "0001" },
        { label: "微信小程序门店版", value: "0002" },
        { label: "易掌柜", value: "0003" },
        { label: "业务管理后台", value: "0004" },
      ],
      ruleValidate: {
        // platformCode: [
        //   { required: true, message: "请选择平台编码", trigger: "change" },
        // ],
        priceSpGroup: [
          { required: true, message: "请选择定价分组", trigger: "change" },
        ],
        retGrade: [
          { required: true, message: "请选择门店等级编码", trigger: "change" },
        ],
        skuCode: [
          { required: true, message: "请输入SKU编码", trigger: "blur" },
        ],
        spCode: [
          { required: true, message: "请选择资金商编码", trigger: "change" },
        ],
        spGroup: [
          { required: true, message: "请选择供货分组", trigger: "change" },
        ],
        price: [
          {
            validator: (rule, value, callback) =>
              validateHandler(
                "请输入正确的格式",
                /^[0-9]+([.]{1}[0-9]+){0,1}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        retailPrice: [
          {
            validator: (rule, value, callback) =>
              validateHandler(
                "请输入正确的格式",
                /^[0-9]+([.]{1}[0-9]+){0,1}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
        untaxedPrice: [
          {
            validator: (rule, value, callback) =>
              validateHandler(
                "请输入正确的格式",
                /^[0-9]+([.]{1}[0-9]+){0,1}$/,
                value,
                callback
              ),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getSpInfoQueryAll();
    this.getList(this.searchForm);
    this.getSpGroupQueryAll();
  },
  methods: {
    // 列表
    async getList(params = {}) {
      const { data, total } = await this.$api["priceSearch"](params);
      this.tbList = data;
      this.total = total;
    },
    async getSpInfoQueryAll() {
      const { data } = await this.$api["spInfoQueryAll"]();
      this.spInfoQueryAll = data;
    },
    async getSpGroupQueryAll() {
      const { data } = await this.$api["spGroupQueryAll"]();
      this.spGroupQueryAll = data;
    },
    handleSearch() {
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      const params = {
        ...this.searchForm,
      };
      this.getList(params);
    },
    // 页码
    pageChange(d) {
      this.searchForm.page = d;
      this.getList(this.searchForm);
    },
    // 页数
    pageSizeChange(d) {
      this.searchForm.pageSize = d;
      this.getList(this.searchForm);
    },
    // 重置
    resetList() {
      this.$refs.searchForm.resetFields();
      this.searchForm.page = 1;
      this.searchForm.pageSize = 10;

      this.searchForm.spCode = "";
      this.searchForm.platformCode = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    async handleSave() {
      this.$refs["formValidate"].validate(async (valid) => {
        if (valid) {
          this.modalLoading = true;
          const params = {
            ...this.formValidate,
            id: this.editId,
          };

          const { data, code } =
            this.formTitle == "新增"
              ? await this.$api["priceAdd"](params)
              : await this.$api["priceUpdate"](params);
          if (code == "200") {
            this.$Message.success(`${this.formTitle}成功`);
            this.editId = "";
            this.formValidate = { ...initFormValidate };
            this.formModel = false;
            this.modalLoading = false;
            this.getList(this.searchForm);
          }
        }
      });
    },
    // 日志
    detailFn(d, i) {},
    // 删除部门
    removeFn(d) {
      let that = this;
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.erpCode}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          if (!d.id) {
            this.$Message.error("id字段缺失");
            return false;
          }
          const params = {
            id: d.id,
          };
          const { code } = await this.$api["priceDelete"](params);
          if (code == "200") {
            this.$Message.success("删除成功");
            this.getList(this.searchForm);
          } else {
            this.$Message.error("删除失败");
          }
        },
      });
    },
    handleOpenDeatil(v) {
      if (!v) {
        this.$Message.error("商品code不能为空");
        return false;
      }
      this.$router.push({
        path: "/skuInfo/detail",
        query: {
          code: v,
        },
      });
    },
    handleCancel() {
      this.editId = "";
      this.formModel = false;
      this.formValidate = { ...initFormValidate };
    },
    handleAdd() {
      this.formTitle = "新增";
      this.editId = "";
      this.formModel = true;
      this.formValidate = { ...initFormValidate };
    },
    handleEdit(v) {
      this.formTitle = "编辑";
      this.editId = v.id;
      this.formModel = true;
      const code = this.platformCodeList.filter(
        (item) => item.label == v.platformName
      );
      this.formValidate = {
        ...v,
        platformCode: code[0] ? code[0].value : "",
        retailPrice: v.price || "",
      };
    },
  },
};
</script>
<style scoped>
.tip {
  color: #ccc;
}

.logo {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/commodity/priceInfo.vue